import PropTypes from 'prop-types';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      Please ensure you are at the property where the appointment will be held at least
      <strong> 5 mins </strong>
      before your scheduled appointment time
    </li>
    <li>
      Our designer will bring a full set of samples with them so you can see all finishes and
      features. They&rsquo;ll discuss your specific requirements and storage needs and after
      measuring your room and creating a floor plan, they&rsquo;ll produce a 3D drawing of how your
      room will look. Once you’ve agreed the plan, the designer will prepare a detailed,
      no-obligation quotation that includes delivery and installation
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
